import {Component, HostListener, OnInit} from '@angular/core';
import {MediaObserver} from '@angular/flex-layout';
import {getPdfViewZoomLevel} from '../common/utility';

@Component({
  templateUrl: './web.component.html',
  styleUrls: ['./web.component.scss']
})
export class WebComponent implements OnInit {
  stepsCreateDocDefaultsSrc = '../../../assets/pdf/create-doc-from-gmail/steps-create-doc-with-defaults.pdf';
  diagramCreateDocDefaultsSrc = '../../../assets/pdf/create-doc-from-gmail/diagram-create-doc-with-defaults.pdf';
  mockCreateDocDefaultsHighlightText = '../../../assets/img/create-doc-from-gmail/mock-create-doc-defaults-highlight-text.png';
  mockCreateDocDefaultsMoreMenu = '../../../assets/img/create-doc-from-gmail/mock-create-doc-defaults-more-menu.png';
  mockNewDocFromGmail = '../../../assets/img/create-doc-from-gmail/mock-new-doc-from-gmail.png';
  mockIlluminatingCoWeb = '../../../assets/img/illuminating-company/mock-illuminating-co-web.png';
  mockIlluminatingCoWebLogin = '../../../assets/img/illuminating-company/mock-illuminating-co-web-login.png';
  mockIlluminatingCoWebNav = '../../../assets/img/illuminating-company/mock-illuminating-co-web-nav.png';
  mockIlluminatingCoPhone = '../../../assets/img/illuminating-company/mock-illuminating-co-phone.png';
  mockIlluminatingCoPhoneMenu = '../../../assets/img/illuminating-company/mock-illuminating-co-phone-menu.png';
  imgZephyrLogoOfficial = '../../../assets/img/zephyr-recruiting/zephyr-logo-official.png';
  imgZephyrLogoInitial = '../../../assets/img/zephyr-recruiting/zephyr-logo-original.png';
  imgZephyrLogoWisps = '../../../assets/img/zephyr-recruiting/zephyr-logo-wisps.png';
  imgZephyrLogoText = '../../../assets/img/zephyr-recruiting/zephyr-logo-text.png';
  imgZephyrWisps = '../../../assets/img/zephyr-recruiting/zephyr-wisps.png';
  imgZephyrScreenshot = '../../../assets/img/zephyr-recruiting/zephyr-screenshot.png';

  constructor(
    public mo: MediaObserver
  ) {
  }

  ngOnInit(): void {
    this.getPdfViewZoomLevel();
  }

  @HostListener('window:resize')
  getPdfViewZoomLevel(): number {
    return getPdfViewZoomLevel();
  }
}
